<template>
    <a href="https://capitalcitychorus.org" target="_blank" :class="{ [`ccc-link-${size}`]: true }" class="ccc-link">
        <img src="@/assets/img/ccc-logo-std-black-bgtransparent.png" alt="Organized by Ottawa's Capital City Chorus" />
    </a>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            validator: prop => !!prop && prop.match(/^(sm|md)$/),
            default: "md"
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/variables";

.ccc-link {
    img {
        max-height: 1.2rem;
    }
    &.ccc-link-sm {
        img {
            max-height: 0.9rem;
        }
    }
}
</style>
